<template>
  <BLayoutView
    :title="pageTitle"
    hidden-footer
  >
    {{ pageTitle }}
  </BLayoutView>
</template>

<script>
import { DashboardCollectorModel as Model } from './Model'
import BLayoutView from '@/components/layouts/BLayoutView.vue'


export default {
  name: 'ViewDashboardLkIndex',
  components: {
    BLayoutView,
  },
  data() {
    return {
      pageTitle: Model.page_title.index,
    }
  },
}
</script>
